/**
 * Move an element within an array from one index to another.
 *
 * @param array - Original array.
 * @param from - Move item from index.
 * @param to - Move item to index.
 */
export const moveArrayItem = <T>(array: T[], from: number, to: number): T[] => {
	const newArr = [...array];

	const item = newArr.splice(from, 1)[0];
	newArr.splice(to, 0, item);

	return newArr;
};
